
<template>
  <div class="container-fluid" style="display:none" v-show="isLoaded == true">
    <div class="row">
      <div class="mr-2" style="width:20px;">
        <button type="button" ref="prev" :disabled="isInFirstPage" @click="onClickPreviousPage" class="btn btn-float px-0" style="position: relative;margin-top:calc(50% - 0px);"><i class="icon-arrow-left32 "></i></button>
      </div>
      <div style="position:relative;">
        <div class="animatestart animated" ref="container" style="">
          <slot></slot>
        </div>        
      </div>
     <div class="ml-2" style="width:20px;">
       <button type="button" ref="next" :disabled="isInLastPage" @click="onClickNextPage" class="btn btn-float  px-0" style="position: relative; margin-top: calc(50% - 0px);"><i class="icon-arrow-right32 "></button>
      </div>
    </div>
    
    <div class="row">
      <div class="col">
        <ul class="pagination">
          
          <li v-for="page in pages"
              class="pagination-item">
            <button type="button"
                    @click="onClickPage(page.name)"
                    :disabled="page.isDisabled"
                    :class="{ active: isPageActive(page.name) }">
              {{ page.name }}
            </button>
          </li>
        </ul>
        </div>
      </div>
    </div>
  </template>

  <script>

    import { nextTick } from 'vue'

    export default {
      name: 'simple-carousel',
      components: {
      },
      props: {
        value: {
          required: false,
          type: Array,
          default: null
        },
        list: {
          required: false,
          type: Array,
          default: null
        },
        perPage: {
          type: Number,
          required: false,
          default: 5,
        },
        mobilePerPage: {
          type: Number,
          required: false,
          default: 3,
        }
      },
      data() {
        return {
          elements: [],
          isLoaded: false,
          totalPages: 0,
          currentPage: 0,
          showAnimation: false,
        }
      },
      methods: {

        removeAnimation() {
          var classList = this.$refs.container.classList;
          classList.add('hidden');
          classList.remove('fadeInRight');
          classList.remove('fadeInLeft');
        },
        addAnimation(animation) {

          var thisContext = this;
         
          if (animation == "prev") {
            animation = 'fadeInLeft';
          }
          else
            animation = 'fadeInRight';

          var classList = this.$refs.container.classList;
          classList.remove('hidden');
          classList.add(animation);

          setTimeout(function () {
            thisContext.$refs.prev.classList.remove('hidden');
            thisContext.$refs.next.classList.remove('hidden');
          }, 800)


          
        },
        onClickFirstPage() {
          
          this.pageChange(1);
          this.$emit('pagechanged', 1);
        },
        onClickPreviousPage() {
          this.$refs.prev.classList.add('hidden');
          this.$refs.next.classList.add('hidden');

          this.pageChange(this.currentPage - 1, "prev");
          this.$emit('pagechanged', this.currentPage - 1);
        },
        onClickPage(page) {
          this.pageChange(page, "next");
          this.$emit('pagechanged', page);
        },
        onClickNextPage() {

          this.$refs.prev.classList.add('hidden');
          this.$refs.next.classList.add('hidden');

          this.pageChange(this.currentPage + 1);
          this.$emit('pagechanged', this.currentPage + 1);
        },
        onClickLastPage() {
          this.pageChange(this.totalPages);
          this.$emit('pagechanged', this.totalPages);
        },
        reset() {
          Vue.nextTick(() => {
            this.$forceUpdate();
            this.initContent();
          })
        },
        pageChange(page, animation) {

          


          this.currentPage = page;

          var perPage = this.perPage;
          if (this.$store.isMobile() == true)
            perPage = this.mobilePerPage;

          this.removeAnimation();

          const elements = this.$slots.default.filter(node => node.elm && node.elm.classList);
          var start = (this.currentPage - 1) * perPage;
          var end = start + perPage;
          var count = 0;
          var itemsShowing = 0;
          for (var i = 0; i < elements.length; i++) {
            var classList = elements[i].elm.classList;
            classList.add('index' + count);
            if (count >= start && count < end && itemsShowing < perPage) {
              classList.remove('hidden');
              classList.add('removed-hidden');
              itemsShowing++;
            }
            else {
              classList.add('hidden');
              classList.remove('removed-hidden');
            }
            count++;
          }

          var thisContext = this;
          setTimeout(function () {
            thisContext.addAnimation(animation);
          }, 1000);
        
        },
        initContent() {

          var thisContext = this;

          if (!this.$slots.default) {
            setTimeout(function () {
              thisContext.initContent();
            }, 1000)
            return;
          }

          var contents = [];
          const elements = this.$slots.default.filter(node => node.elm && node.elm.classList);

          if (!elements || elements.length == 0) {
            setTimeout(function () {
              thisContext.initContent();
            }, 1000)
            return;
          }
          else {
          }

          
          var perPage = this.perPage;
          if (this.$store.isMobile() == true)
            perPage = this.mobilePerPage;

          this.totalPages = Math.ceil(elements.length / perPage);
          
          // Hide all elements
          for (var vnode of elements) {
            if (vnode.elm && vnode.elm.classList) {
              var classList = vnode.elm.classList;
              classList.add('hidden');
            }
          }

          this.pageChange(1);
          this.elements = contents;
          this.isLoaded = true;
        },
        isPageActive(page) {
          return this.currentPage === page;
        },
        
      },
      created() {

      },
      
      mounted() {
        this.initContent();
      },
      computed: {
        isloaded() {
          return this.isLoaded;
        },
        startPage() {
          // When on the first page
          if (this.currentPage === 1) {
            return 1;
          }

          // When on the last page
          if (this.currentPage === this.totalPages) {
            return this.totalPages;
          }

          // When inbetween
          return this.currentPage - 1;
        },
        pages() {
          const range = [];

          for (
            let i = this.startPage;
            i <= Math.min(this.startPage - 1, this.totalPages);
            i++
          ) {
            range.push({
              name: i,
              isDisabled: i === this.currentPage
            });
          }

          return range;
        },
        isInFirstPage() {
          return this.currentPage === 1;
        },
        isInLastPage() {
          return this.currentPage === this.totalPages;
        },
      }
    }
  </script>

  <style scoped>

    .animatestart {
      opacity: 1;
      transform: translateX(0px);
    }

    .hidden {
      display: none;
      opacity: 0;
    }

    .pagination {
      list-style-type: none;
    }

    .pagination-item {
      display: inline-block;
    }

    .active {
      background-color: #4AAE9B;
      color: #ffffff;
    }
  </style>

  <!--
  <style>
    simple-carousel {
      display: none;
    }
  </style>
  -->



// WEBPACK FOOTER //
// src/components/carousel/simple-carousel.vue